/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_8_PInputs */

const en_privacy_8_p = /** @type {(inputs: Privacy_8_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data is encrypted in transit (TLS) and stored on servers with access limited to the Bystep team. API tokens are shown once and stored hashed. No system is perfectly secure; report any concern to the email below.`)
};

const id_privacy_8_p = /** @type {(inputs: Privacy_8_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data dienkripsi saat transit (TLS) dan disimpan di server dengan akses terbatas pada tim Bystep. Token API hanya ditampilkan sekali dan disimpan dalam bentuk hash. Tidak ada sistem yang sepenuhnya aman; laporkan kekhawatiran apa pun ke email di bawah.`)
};

/**
* | output |
* | --- |
* | "Data is encrypted in transit (TLS) and stored on servers with access limited to the Bystep team. API tokens are shown once and stored hashed. No system is pe..." |
*
* @param {Privacy_8_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_8_p = /** @type {((inputs?: Privacy_8_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_8_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_8_p(inputs)
	return en_privacy_8_p(inputs)
});